<template>
  <div>
    <el-table v-loading="isLoading" :data="searchTable">
      <el-table-column 
        v-for="(item, index) in columnList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :sortable="item.sortable"
      />
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    searchTable: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      columnList: [
        { label: '日期', prop: 'accountPeriod', sortable: true},
        { label: '城市', prop: 'regionName'},
        { label: '校园', prop: 'street'},
        { label: '骑行收入', prop: 'rideAmount'},
        { label: '摊销收入', prop: 'tanxiaoAmount'},
        { label: '总收入', prop: 'totalAmount'},
      ],
    }
  }
}
</script>
